module.exports = __webpack_public_path__ + "static/img/jsz.f7f0ee3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/jsz.png
// module id = ssOP
// module chunks = 0